import { createSlice } from '@reduxjs/toolkit';

export const customCounsellingOneSlice = createSlice({
  name: 'customCounsellingOne',
  initialState: {
    allDataOne: null,
  },
  reducers: {
    setAllDataOne: (state, action) => {
      state.allDataOne = action.payload;
    },
  },
});

export const { setAllDataOne } = customCounsellingOneSlice.actions;
export default customCounsellingOneSlice.reducer;
